(() => {
  const pending = new Map();
  const getUrl = (node) => {
    const url = new URL(node.hasAttribute('data-one-count-current') ? location.href : node.dataset.oneCountUrl, location.origin);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    return url;
  };
  const countVariants = async (base) => {
    let count = 0;
    let page = 1;
    const visited = new Set();
    while (page) {
      if (visited.has(page)) throw new Error('Repeated count page');
      visited.add(page);
      const url = new URL(base);
      url.searchParams.set('section_id', 'one-variant-count');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Count request failed');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = document.querySelector('[data-one-variant-count]');
      if (!result) throw new Error('Count response missing');
      const part = Number(result.dataset.oneVariantCount);
      const next = Number(result.dataset.oneNextPage || 0);
      if (!Number.isSafeInteger(part) || part < 0 || !Number.isSafeInteger(next) || next < 0) throw new Error('Invalid count');
      count += part;
      page = next;
    }
    return count;
  };
  const update = () => {
    document.querySelectorAll('[data-one-catalog-count]').forEach((node) => {
      const url = getUrl(node).href;
      if (node.dataset.oneCountRequested === url) return;
      node.dataset.oneCountRequested = url;
      node.setAttribute('aria-busy', 'true');
      if (!pending.has(url)) pending.set(url, countVariants(url).catch((error) => { pending.delete(url); throw error; }));
      pending.get(url).then((count) => {
        if (!node.isConnected || node.dataset.oneCountRequested !== url) return;
        node.textContent = (node.dataset.oneCountFormat || '__COUNT__').replaceAll('__COUNT__', String(count));
        node.removeAttribute('aria-busy');
        node.hidden = false;
      }).catch(() => {
        if (node.dataset.oneCountRequested !== url) return;
        node.removeAttribute('aria-busy');
        node.hidden = true;
      });
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; update(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('popstate', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
